export default __webpack_public_path__ + "static/sparta-rash-48fe534eaf2894d6d84d1782ac5473dc.png";